import { loginAPI } from "../../../apis/LoginAPI.jsx";
import { settingsAPI } from "../../../apis/SettingsAPI.jsx";

export default class SettingsService {
  getClientConfig(token, setState) {
    loginAPI
      .getClientConfig(token)
      .then((response) => {
        if (response.status === 200 && response.data) {
          setState({
            loading: false,
            firstName: response.data.fname,
            lastName: response.data.lname,
            email: response.data.email,
            phone: response.data.phone,
            newFirstName: response.data.fname,
            newLastName: response.data.lname,
            newEmail: response.data.email,
            newPhone: response.data.phone,
            authChoice:
              response.data.auth_choice == "auth_pending" ||
              response.data.auth_choice == "auth_declined"
                ? "Phone"
                : "Google Auth",
            phoneValidated: response.data.phone_validated,
            emailValidated: response.data.email_validated,
            idValidated: response.data.id_verified,
            bankAccountVerified: response.data.cybrid_account_status,
            accountType: response.data.person_type,
            domicile: response.data.domicile,
            companyDisplayName: response.data.company_display_name || "",
            companyLogoUrl: response.data.company_logo_url || "",
          });
        } else {
          //Failure
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
      });
  }

  alwasyOn2FA(token, setState) {
    settingsAPI
      .alwasyOn2FA(token)
      .then((response) => {
        console.log(response);
        if (response.status === 200 && response.data.qrcode) {
          setState({
            qrcodeBase64: response.data.qrcode,
            authKey: response.data.key,
            authChoice: "Google Auth",
            showGoogleAuthModal: true,
            loadingSentAuthChange: false,
            authKeyCopied: false,
          });
        } else {
          //Failure
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
      });
  }

  decline2FA(token, setState) {
    settingsAPI
      .decline2FA(token)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setState({
            authChoice: "Phone",
            loadingSentAuthChange: false,
          });
        } else {
          //Failure
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
      });
  }

  changeName(token, state, setState) {
    settingsAPI
      .changeName(token, state.newFirstName, state.newLastName)
      .then((response) => {
        console.log(response);
        var aux = state.changeInfoResults;
        if (response.status === 200) {
          aux.push(true);
          setState({
            firstName: state.newFirstName,
            lastName: state.newLastName,
            finishedNumber: state.finishedNumber + 1,
            changeInfoResults: aux,
          });
        } else {
          //Failure
          aux.push(false);
          setState({
            finishedNumber: state.finishedNumber + 1,
            changeInfoResults: aux,
          });
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
        var aux = state.changeInfoResults;
        aux.push(false);
        setState({
          finishedNumber: state.finishedNumber + 1,
          changeInfoResults: aux,
        });
      });
  }

  confirmPhone(token, setState) {
    loginAPI
      .confirmPhone(token)
      .then((response) => {
        if (response.status === 200) {
          //Success
          var mySubString = response.data.payload.substring(
            response.data.payload.indexOf("[") + 1,
            response.data.payload.lastIndexOf("]]"),
          );

          setState(
            {
              confirmPhoneMessage:
                "xxx-xxx-" +
                mySubString.slice(mySubString.length - 3, mySubString.length),
            },
            () => {
              setState({ loadingPhone: false });
            },
          );
        } else {
          //Failure
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
      });
  }

  deleteAccount(token, code, goToDisableAccountResultPage) {
    settingsAPI
      .deleteAccount(token, code)
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          goToDisableAccountResultPage(true);
        } else {
          //Failure
          goToDisableAccountResultPage(false);
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
        goToDisableAccountResultPage(false);
      });
  }

  deactivateAccount(token, code, goToResultPage) {
    settingsAPI
      .deactivateAccount(token, code)
      .then((response) => {
        if (response.status === 200) {
          goToResultPage(true);
        } else {
          //Failure
          goToResultPage(false);
        }
      })
      .catch((error) => {
        //Failure
        console.log(error);
        goToResultPage(false);
      });
  }
}
